import { Directive, inject } from '@angular/core'
import { ElderSelectComponent, Sort } from '@elderbyte/ngx-starter'
import { WorkStationTypeService } from '../work-station-type.service'

@Directive({
  selector: '[appWorkStationTypeSelect]',
})
export class WorkStationTypeSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/
  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const typeService = inject(WorkStationTypeService)
    this.select.displayProperty = 'name'
    this.select.placeholder = 'context.type'
    this.select.dataSource = typeService
    this.select.sorts = [new Sort('id', 'asc')]
  }
}
